import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calender_icon } from "../../assets/img";

const DateRange2 = ({ selectedDate, setSelectedDate }) => {
  const [open, setOpen] = useState(false);

  // Format Date to YYYY-MM-DD
  const formatDate = (date) => {
    if (!date) return "";
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  // Parse selectedDate safely
  const parsedDate = (() => {
    if (!selectedDate) return null;
    const d = new Date(selectedDate);
    return isNaN(d.getTime()) ? null : d;
  })();

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex calender-input1 mt-3" onClick={onClick} ref={ref}>
      <img src={calender_icon} className="calender-icon me-2" alt="calendar" />
      <input
        type="text"
        value={value || ""}
        placeholder='"Select Date"'
        readOnly
        className="date-input1 placholdercolorchanges2"
      />

    </div>
  ));

  const disableScroll = () => {
    document.documentElement.style.overflow = "hidden"; // <html>
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  return (
    <DatePicker
      selected={parsedDate}
      onChange={(date) => setSelectedDate(formatDate(date))}
      dateFormat="dd-MM-yyyy"
      customInput={<CustomInput />}
      open={open}
      onClickOutside={() => setOpen(false)}
      onSelect={() => setOpen(false)}
      onInputClick={() => setOpen(true)}
      maxDate={new Date()}
      withPortal
      onCalendarOpen={disableScroll}
      onCalendarClose={enableScroll}
    />
  );
};

export default DateRange2;
